<div fxLayout="row" fxLayoutAlign="space-between center" class="section-title">
    <h3>
        {{title}}
        <ng-content></ng-content>
    </h3>
    <div *ngIf="required">*Required</div>
</div>